import React from "react";
import "./UI.css";
import { FiArrowRight, FiCheck, FiInfo, FiCopy } from "react-icons/fi";

export function Card({ className = "", children }) {
  return <div className={`uiCard ${className}`}>{children}</div>;
}

export function Badge({ tone = "brand", children }) {
  return <span className={`uiBadge ${tone}`}>{children}</span>;
}

export function SectionHead({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`uiHead ${align}`}>
      <div className="uiEyebrow">{eyebrow}</div>
      <h2 className="uiH2">{title}</h2>
      {subtitle ? <p className="uiSub">{subtitle}</p> : null}
    </div>
  );
}

export function Button({ variant = "primary", as = "button", className = "", iconRight, children, ...rest }) {
  const Comp = as;
  return (
    <Comp className={`uiBtn ${variant} ${className}`} {...rest}>
      <span className="uiBtnText">{children}</span>
      {iconRight ? <span className="uiBtnIcon">{iconRight}</span> : null}
    </Comp>
  );
}

export function TinyInfo({ icon = <FiInfo />, children }) {
  return (
    <div className="uiTinyInfo">
      <span className="uiTinyIcon">{icon}</span>
      <span>{children}</span>
    </div>
  );
}

export function StatRow({ items }) {
  return (
    <div className="uiStats">
      {items.map((s) => (
        <div className="uiStat" key={s.k}>
          <div className="uiStatNum">{s.v}</div>
          <div className="uiStatLabel">{s.k}</div>
        </div>
      ))}
    </div>
  );
}

export function Checklist({ items }) {
  return (
    <div className="uiChecklist">
      {items.map((t) => (
        <div className="uiCheck" key={t}>
          <FiCheck />
          <span>{t}</span>
        </div>
      ))}
    </div>
  );
}

export function Accordion({ items, defaultOpen = 0 }) {
  const [openIndex, setOpenIndex] = React.useState(defaultOpen);
  return (
    <div className="uiAcc">
      {items.map((it, idx) => {
        const open = idx === openIndex;
        return (
          <button
            key={it.q}
            className={`uiAccItem ${open ? "open" : ""}`}
            onClick={() => setOpenIndex(open ? -1 : idx)}
            type="button"
          >
            <div className="uiAccQ">
              <span>{it.q}</span>
              <span className="uiAccPlus">{open ? "–" : "+"}</span>
            </div>
            {open ? <div className="uiAccA">{it.a}</div> : null}
          </button>
        );
      })}
    </div>
  );
}

export function CopyRow({ label, value, onCopy }) {
  return (
    <button className="uiCopyRow" type="button" onClick={() => onCopy(value)} title="Click to copy">
      <div className="uiCopyLeft">
        <div className="uiCopyLabel">{label}</div>
        <div className="uiCopyValue">{value}</div>
      </div>
      <div className="uiCopyIcon">
        <FiCopy />
      </div>
    </button>
  );
}

export const Icons = { FiArrowRight };